'use strict'
/**
 * Base · SVG wrapper común para todos los iconos del DS.
 * Doctrina: trazo consistente, mismo viewBox, currentColor para herencia.
 */
import React, { forwardRef } from 'react'

export const Icon = forwardRef(function Icon({
  size = 20,
  strokeWidth = 1.6,
  filled = false,
  title,
  children,
  ...rest
}, ref) {
  return (
    <svg
      ref={ref}
      width={size} height={size}
      viewBox="0 0 24 24"
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      role={title ? 'img' : 'presentation'}
      aria-hidden={title ? undefined : true}
      aria-label={title}
      {...rest}
    >
      {title && <title>{title}</title>}
      {children}
    </svg>
  )
})

export default Icon
